module.exports = __webpack_public_path__ + "static/media/whatsapp.ed2cef63.svg";